import { Component, Input, OnInit } from "@angular/core";
import "./trendArrow.scss";

@Component({
    selector: 'trend-arrow',
    template: require('./trendArrow.html')
})

export class TrendArrowComponent {
    @Input() value: any;

    constructor() { }
}
